import { I18n } from '@calendly/i18n'
import { useClose } from '@calendly/ui/components/dropdown'
import { useRef, useState } from 'react'

import { SPECIFIC_DATES } from '../constants'
import { formattedAvailableDays, getTimeSlotsForDays, reorderDays } from '../utils'
import { Calendar } from './calendar'
import { MAX_SELECTED_DAYS } from './constants'
import { Wrapper, Footer, Actions, BackLink, StyledButton } from './styles'

export const SpecificDates = ({
  timezone,
  currentMonthId,
  setCurrentMonthId,
  isLoading,
  availabilityData,
  onClose,
  onApply,
  isSendFromCalendly
}) => {
  const closeDropdown = useClose()
  const [selectedDays, setSelectedDays] = useState([])
  const [selectedDates, setSelectedDates] = useState([])
  const wrapperRef = useRef(null)
  const days = availabilityData?.days || []
  const availableDays = days.filter((day) => day.status === 'available').map((day) => day.date)
  const selectDaysText = I18n.t('publisher.scheduling.offer_time_slots_modal.specific_days.select_limit')
  const selectDatesText = I18n.t('publisher.scheduling.offer_time_slots_modal.specific_dates.select_limit')
  const buttonText = isSendFromCalendly ? I18n.t('publisher.action.insert') : I18n.t('publisher.action.apply')
  const dateLimitText = isSendFromCalendly ? selectDaysText : selectDatesText

  const toggleDay = (day) => {
    const isDayAdded = !selectedDates.includes(day)

    if (isDayAdded && selectedDates.length === MAX_SELECTED_DAYS) return

    const newSelectedDates = isDayAdded
      ? [...selectedDates, day]
      : selectedDates.filter((x) => x !== day)

    setSelectedDates(newSelectedDates)

    const newDay = days.find((d) => d.date === day)

    const updatedDays = isDayAdded
      ? [...selectedDays, newDay]
      : selectedDays.filter((d) => d.date !== day)

    setSelectedDays(reorderDays(updatedDays))
  }

  const handleApply = () => {
    const newAvailableDays = formattedAvailableDays({ days: selectedDays })
    const timeSlotsForDays = getTimeSlotsForDays(SPECIFIC_DATES, newAvailableDays)

    onApply(newAvailableDays, timeSlotsForDays)
    closeDropdown()
  }

  return (
    <Wrapper ref={wrapperRef}>
      <BackLink onClick={onClose} />
      <Calendar
        availableDays={availableDays}
        selectedDates={selectedDates}
        timezone={timezone}
        currentMonthId={currentMonthId}
        setCurrentMonthId={setCurrentMonthId}
        toggleDay={toggleDay}
        isLoading={isLoading}
      />
      <Footer>
        <p>{dateLimitText}</p>
        <Actions>
          <StyledButton onClick={handleApply} size="small" disabled={!selectedDates.length}>
            {buttonText}
          </StyledButton>
        </Actions>
      </Footer>
    </Wrapper>
  )
}
